<template>
    <div>
        <div v-if="this.$route?.name == 'ConsultaContabilizacion'"> 
            <div class="col-md-12 mt-3">
                <h2> {{ labels.title }} </h2> 
            </div>
            <div class="row mt-5">
                <div class="col-md-6 d-flex justify-content-end">
                    <h4>{{ labels.fechaContabilizacion }}</h4> 
                </div>
                <div class="col-md-2 d-flex justify-content-start">
                    <input type="month" :items="fechaContabilizacion" class="form-control">
                </div>
            </div>
            <div class="col-md-12 mt-4">
                <b-button type="button" id="create-btn" @click="procesarContabilizacion">{{ labels.consultar }}</b-button> 
            </div>
        </div>
        <div class="col-md-12 mt-3">
            <div v-if="btnGenExcel" class="row col-md-12 align-items-center d-flex justify-content-end">
                <b-button style="background-color: #2e507a; width: 40px; height: 40px;" class="md-fab md-primary" @click="generaExcelContabilizacion()">
                    <i>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="#ffffff" d="M192 112L304 112L304 200C304 239.8 336.2 272 376 272L464 272L464 512C464 520.8 456.8 528 448 528L192 528C183.2 528 176 520.8 176 512L176 128C176 119.2 183.2 112 192 112zM352 131.9L444.1 224L376 224C362.7 224 352 213.3 352 200L352 131.9zM192 64C156.7 64 128 92.7 128 128L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 250.5C512 233.5 505.3 217.2 493.3 205.2L370.7 82.7C358.7 70.7 342.5 64 325.5 64L192 64zM291.2 329.6C283.2 319 268.2 316.8 257.6 324.8C247 332.8 244.8 347.8 252.8 358.4L290 408L252.8 457.6C244.8 468.2 247 483.2 257.6 491.2C268.2 499.2 283.2 497 291.2 486.4L320 448L348.8 486.4C356.8 497 371.8 499.2 382.4 491.2C393 483.2 395.2 468.2 387.2 457.6L350 408L387.2 358.4C395.2 347.8 393 332.8 382.4 324.8C371.8 316.8 356.8 319 348.8 329.6L320 368L291.2 329.6z"/></svg> 
                    </i>
                </b-button>
            </div>
            <div class="row col-md-12 justify-content-center" v-if="listContabilizacion != 0">
                <b-table md-card md-header :items="listContabilizacion">
                    <b-table-row slot="b-table-row" slot-scope="{ item }">
                        <b-table-cell :md-label="labels.nroContrato" class="border">{{ item?.nro_contrato }}</b-table-cell> 
                        <b-table-cell :md-label="labels.fecha" class="border">{{ item?.fecha_contabilizacion }}</b-table-cell> 
                        <b-table-cell :md-label="labels.tipo_contrato" class="border">{{ getNombreTipoCont(item?.tipo_contrato) }}</b-table-cell> 
                        <b-table-cell :md-label="labels.tipo_activo" class="border">{{ getNombreTipoAct(item?.tipo_activo) }}</b-table-cell> 
                        <b-table-cell :md-label="labels.nro_cuenta" class="border">{{ item?.nro_cuenta }}</b-table-cell> 
                        <b-table-cell :md-label="labels.nombre_cuenta" class="border">{{ item?.nombre_cuenta }}</b-table-cell> 
                        <b-table-cell :md-label="labels.debito" class="border">{{ item?.debito }}</b-table-cell> 
                        <b-table-cell :md-label="labels.credito" class="border">{{ item?.credito }}</b-table-cell> 
                        <b-table-cell :md-label="labels.codigo_centro_costo" class="border">{{ item?.codigo_centro_costo }}</b-table-cell> 
                    </b-table-row>
                </b-table>
            </div>
            <div v-else>
                <div v-if="this.$route?.name == 'ConsultaContabilizacion'"> 
                    <h5>{{ labels.noRow }}</h5> 
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as XLSX from "exceljs";
import ContratoContabilizacion from '../../services/ContratoContabilizacion' 
import TipoActivo from '../../services/TipoActivo' 
import TipoContrato from '../../services/TipoContrato' 

export default {
    name : 'ConsultaContabilizacion',
    props : ['listContabilizacion'],
    data : () => ({
        fechaContabilizacion : '',
        lstTipoContrato : [],
        lstTipoActivo : [],
        btnGenExcel : false
    }),
    computed : {
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Consulta contabilización',
                    fechaContabilizacion : 'Fecha contabilización:',
                    nroContrato : 'Nro. contrato', 
                    fecha : 'Fecha contabilización',
                    consultar : 'Consultar',
                    tipo_contrato : 'Tipo contrato',
                    tipo_activo : 'Tipo activo',
                    nro_cuenta : 'Cuenta',
                    nombre_cuenta : 'Nombre cuenta',
                    debito : 'Débito',
                    credito : 'Crédito',
                    codigo_centro_costo : 'Centro costo',
                    noRow : 'No hay registros.' 
                }
            }else{
                return {
                    title : 'Accounting query',
                    fechaContabilizacion : 'Posting date:',
                    nroContrato : 'Contract number',
                    fecha : 'Posting date',
                    consultar : 'Consult',
                    tipo_contrato : 'Contract type',
                    tipo_activo : 'Active type',
                    nro_cuenta : 'Account',
                    nombre_cuenta : 'Account name',
                    debito : 'Debit',
                    credito : 'Credit',
                    codigo_centro_costo : 'Cost center',
                    noRow : 'There are not records.' 
                }
            }
        }
    },
    methods : {
        procesarContabilizacion(){
            if(this.fechaContabilizacion != ''){ 

                ContratoContabilizacion.getContabilizacionByFechaContab(this.fechaContabilizacion) 
                .then((res) => { 
                    this.listContabilizacion = res.data.listContabilizacion 

                    if(this.listContabilizacion.length != 0){ 
                        this.btnGenExcel = true 
                    }else{
                        this.btnGenExcel = false 
                    }
                })
                .catch((err) => console.log(err)) 

            }else{
                this.$toast.error('Diligenciar la fecha.') 
            }
        },
        getNombreTipoCont(num){
            let tipoContrato = this.lstTipoContrato.find((obj) => obj.tipo_contrato == num) 
            return tipoContrato?.descripcion 
        },
        getNombreTipoAct(num){
            let tipoActivo = this.lstTipoActivo.find((obj) => obj.tipo_activo == num) 
            return tipoActivo?.descripcion 
        },
        async generaExcelContabilizacion(){
            const {Workbook} = XLSX
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("Contabilización "+this.fechaContabilizacion) 

            const titulo = ["Contabilización - vigencia "+this.fechaContabilizacion] 
            worksheet.addRow(titulo) 
            worksheet.mergeCells('A1:H1') 
            worksheet.getCell('A1').font = { bold : true, size : 12}; 
            worksheet.getCell('A1').alignment = { horizontal : 'center'}; 

            const tituloCelda = [
                'Nro. contrato', 
                'Fecha contabilización',
                'Tipo contrato',
                'Tipo activo',
                'Cuenta',
                'Nombre cuenta',
                'Débito',
                'Crédito',
                'Centro costo'
            ]
            worksheet.addRow(tituloCelda) 
            for	(let fila = 1;fila<=2;fila++) {
                worksheet.getRow(fila).font = { 
                    name: "Arial Black",
                    family: 2,
                    size: 11,
                    bold: true
                }
            }

            this.listContabilizacion.map((e) => { 
                worksheet.addRow([ 
                    e.nro_contrato, 
                    e.fecha_contabilizacion, 
                    this.getNombreTipoCont(e.tipo_contrato), 
                    this.getNombreTipoAct(e.tipo_activo), 
                    e.nro_cuenta, 
                    e.nombre_cuenta, 
                    parseFloat(e.debito), 
                    parseFloat(e.credito), 
                    e.codigo_centro_costo 
                ])
            })

            //Poner borde
            const border = {
                top : {style : 'thin'},
                left : {style : 'thin'},
                bottom : {style : 'thin'},
                right : {style : 'thin'},
            }
            
            for( let row = 1; row <= worksheet.rowCount; row++){ 
                for( let col = 1; col <= worksheet.columnCount; col++){ 
                    worksheet.getCell(row, col).border = border; 
                }
            }
            //------

            const file = await workbook.xlsx.writeBuffer() 
            const downloadLink = document.createElement("a") 
            downloadLink.download = "Contabilización "+this.fechaContabilizacion+".xlsx" 
            downloadLink.href = window.URL.createObjectURL( 
                new Blob([file], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 
                })
            )

            downloadLink.style.display = "none"; 

            document.body.appendChild(downloadLink); 
            downloadLink.click(); 

            downloadLink.remove(); 
        }
    },
    mounted(){
        TipoContrato.getAllTipoContrato() 
        .then((res) => { 
            // console.log(res.data.listTipoContrato); 
            this.lstTipoContrato = res.data.listTipoContrato 
        })
        .catch((e) => console.log(e)) 

        TipoActivo.getAllTipoActivo() 
        .then((res) => { 
            // console.log(res.data.listTipoActivo); 
            this.lstTipoActivo = res.data.listTipoActivo 
        })
        .catch((e) => console.log(e)) 
    }
}
</script>

<style>

</style>
